import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

interface propTypesButton {
  onClick?: any;
  className?: string;
  tag?: any;
  color?: string;
  href?: string;
  size?: string;
  loading?: boolean;
  wide?: boolean;
  wideMobile?: boolean;
  disabled?: boolean;
  children?: any;
}

const defaultProps: propTypesButton = {
  tag: 'button',
  color: '',
  size: '',
  loading: false,
  wide: false,
  wideMobile: false,
  disabled: false
};

const Button: FunctionComponent<propTypesButton> = ({
  className,
  tag,
  color,
  size,
  loading,
  wide,
  wideMobile,
  disabled,
  ...props
}) => {
  const classes = classNames(
    'button',
    color && `button-${color}`,
    size && `button-${size}`,
    loading && 'is-loading',
    wide && 'button-block',
    wideMobile && 'button-wide-mobile',
    className
  );

  const Component = tag;
  return <Component {...props} className={classes} disabled={disabled} />;
};

Button.defaultProps = defaultProps;
export default Button;
